import { Box, IconButton, Input, Stack, TableCell, TableRow, TextField } from '@mui/material'
import React, { useRef } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import DoneIcon from '@mui/icons-material/Done';
import FactCheckIcon from '@mui/icons-material/FactCheck';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CancelIcon from '@mui/icons-material/Close';

const EditRowMoverAdd = ({ row, handleUpdate, setEditRowId, showAlerta }) => {
    const cantidadRef = useRef();


    const handleUpdateClick = (event, row) => {
        event.preventDefault();
        handleEditCantidad(row);
        /*
        let cantidad = parseInt(cantidadRef.current.value);     //Cantidad a mover del almacen a la tienda
        
        if(cantidad > row.cantDisp || cantidad < 0) {
            //Desplegar mensaje de que esa cantidad no está disponible
            console.log('Cantidad no disponible');
            setEditRowId(0);
        } else {
            const total = cantidad * row.price;
            const newRow = {...row, cantidad, total};
            console.log({newRow, cantidad, total});
            handleUpdate(newRow);    
        }
        */
    }

    const handleEditCantidad = (row) => {
        let cantidad = parseInt(cantidadRef.current.value);     

        //console.log('handleEditCantidad: ', cantidad);

        if (cantidad == row.cantDisp) {
            //console.log('No se modificó la cantidad.');
        } else {
            if (cantidad < 1) {
                //console.log('La cantidad minima es 1');
                cantidad = 1;
            } else {
                if (cantidad > row.cantDisp) {
                    //Desplegar mensaje de que esa cantidad no está disponible
                    //console.log('Cantidad no disponible, solo hay: ', row.cantDisp);
                    showAlerta('Cantidad no disponible, solo hay: ' + row.cantDisp);
                    cantidad = row.cantDisp;
                }
            }
            const total = cantidad * row.price;
            const newRow = { ...row, cantidad, total };
            //console.log({ newRow, cantidad, total });
            handleUpdate(newRow);
        }
        setEditRowId(0);
    }

    const handleCancelClick = (event, row) => {
        event.preventDefault();
        setEditRowId(0);
    }

    return (
        <TableRow key={row.id}>
            <TableCell key={row.id + '_id'} align='left'>{row.id}</TableCell>
            <TableCell key={row.id + '_codbar'} align='left'>{row.codBar}</TableCell>
            <TableCell key={row.id + '_product'} align='left'>{row.product}</TableCell>
            <TableCell key={row.id + '_price'} align='left'>{row.price}</TableCell>
            <TableCell key={row.id + '_mov'} align='left'>
                <Box sx={{ width: '100px' }}>
                    <TextField
                        size='small'
                        type='number'
                        inputRef={cantidadRef}
                        required='required'
                        placeholder='0'
                        name='cantidad'
                        defaultValue={row.cantidad}
                        inputProps={{
                            onKeyPress: event => {          //Para gestionar enter
                                const { key } = event;
                                if (key === "Enter") {
                                    handleEditCantidad(row);
                                }
                            },
                            minLength: 8
                        }}
                    />
                </Box>
            </TableCell>
            <TableCell key={row.id + '_tot'} align='left'>{Number(row.total).toFixed(2)}</TableCell>
            <TableCell key={'controles_' + row.id} align='left'>
                <Stack direction='row' spacing={0}>
                    <IconButton aria-label="save" onClick={(event) => handleUpdateClick(event, row)}>
                        <DoneIcon fontSize="small" />
                    </IconButton>
                    <IconButton aria-label="cancel" onClick={(event) => handleCancelClick(event, row)}>
                        <CancelIcon fontSize="small" />
                    </IconButton>
                </Stack>
            </TableCell>
        </TableRow>
    )
}

export default EditRowMoverAdd